import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "my-needs-wrap"
};
const _hoisted_2 = {
  class: "my-needs-container"
};
const _hoisted_3 = {
  class: "my-needs-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_bread_crumb = _resolveComponent("bread-crumb");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_bread_crumb), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view)])])]);
}